import {
  JOIN_GAME_REQUEST,
  JOIN_GAME_REQUEST_SUCCESS,
  JOIN_GAME_REQUEST_ERROR, UPDATE_ACTIVE_OVERLAY_ID,
  UPDATE_OPEN_SITUATION_ID, SHOWBLUR_IMAGE, UPDATE_OPEN_SITUATION_ARRAY
} from "../actionTypes/type";

const initialState = {
  data: null,
  isLoading: false,
  activeCardoverlayId: -1,
  openSituationId:-1,
  showBlurImage: false,
  openSituationArray: []
};

const joinReducer = (state = initialState, action) => {
  let object;

  switch (action.type) {
    case UPDATE_ACTIVE_OVERLAY_ID:
      object = {
        ...state,
        activeCardoverlayId: action.payload,
      };
      break;
    case UPDATE_OPEN_SITUATION_ID:
      object = {
        ...state,
        openSituationId: action.payload,
      };
      break;
    case SHOWBLUR_IMAGE:
      object = {
        ...state,
        showBlurImage: action.payload,
      };
      break;
    case UPDATE_OPEN_SITUATION_ARRAY:
      object = {
        ...state,
        openSituationArray: action.payload,
      };
      break;

    case JOIN_GAME_REQUEST:
      object = {
        ...state,
        isLoading: true,
      };
      break;

    case JOIN_GAME_REQUEST_ERROR:
      object = {
        ...state,
        isLoading: false,
      };
      break;

    case JOIN_GAME_REQUEST_SUCCESS:
      object = {
        ...state,
        data: action.payload,
        isLoading: false,
      };
      break;

    default:
      object = state;
      break;
  }
  return object;
}

export default joinReducer;
